<div class="flex-column page-not-found">
  <h1> {{ 'info.page_not_found' | translate }} </h1>
</div>
